<template>
  <div class="select-folder__wrap" v-if="isModalOpen">
    <div class="select-folder__modal">
      <!-- head -->
      <h3 class="form-item py-5">添加至資料夾</h3>
      <!-- body -->
      <section class="form-item py-5">
        <SimpleSelectWithSearchInput
          buttonPlaceholder="請選擇資料夾"
          :isOnlyShowButtonPlaceholder="true"
          buttonWidth="100%"
          modalWidth="100%"
          :options="folders"
          :selectedValue.sync="selectedFolder"
        ></SimpleSelectWithSearchInput>
      </section>
      <!-- foot -->
      <section class="pa-5 d-flex justify-end">
        <button class="btn w-100px mr-10px" @click="cancelHandler">取消</button>
        <button class="btn btn-primary w-100px" @click="saveHandler">
          儲存
        </button>
      </section>
    </div>
  </div>
</template>

<script>
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';

export default {
  components: {
    SimpleSelectWithSearchInput,
  },
  props: {
    isModalOpen: {
      type: Boolean,
      default: true,
    },
    currentImage: {
      type: Object,
      default: () => ({
        id: '',
        url: '',
        folder: '',
      }),
    },
    folders: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedFolder: '',
    };
  },
  watch: {
    isModalOpen() {
      this.selectedFolder = this.currentImage.folder;
    },
  },
  methods: {
    cancelHandler() {
      this.$emit('cancel-event');
      this.$emit('update:isModalOpen', false);
    },
    saveHandler() {
      this.$emit('save-event', {
        id: this.currentImage.id,
        folder: this.selectedFolder,
      });
      this.$emit('update:isModalOpen', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.select-folder {
  &__wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 7, 25, 0.6);
    z-index: 5;
  }
  &__modal {
    width: 720px;
    margin: 0 auto;
    margin-top: 168px;
    background-color: #fff;
    border-radius: 4px;
  }
}
</style>
